import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { DepartmentModel } from '../../models';
import { DepartmentService } from '../../services';
import { modalSmall, modalLarge } from '../../shared/modules/dialogOptions'

@Component({
    selector: 'app-departments-edit',
    templateUrl: './departments-edit.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class DepartmentEditComponent extends BaseComponent implements OnInit {
    @Output() departmentListView = new EventEmitter();
    public isAdminOrUserEditor: boolean;
    public showSpinner: boolean = false;
    model: any;
    departMentId: number;
    dataToDelete: any;
    public objectConfirm: any; // todo: not implemented

    constructor(
        private departmentService: DepartmentService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastsManager,
        public activeModal: NgbActiveModal, private modalService: NgbModal,
        private location: Location) {
        super(router);
    }

    public ngOnInit() {
        this.model = new DepartmentModel();
        this.setDefaults(this.departMentId);
    }

    public setDefaults(departmentId: number) {
        this.departmentService.getDepartment(departmentId)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                this.model = response.Data;
            });
    }

    public saveChanges() {
        this.showSpinner = true;
        this.model.AccountId = super.currentLoggedUser().accountId;
        this.departmentService.saveDepartment(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.toastr.error(response.Message, "Error");
                }
                this.ngOnInit();
                this.closeDepartmentCreateView();
            });
    }
    public openDelete(title: string) {
        //this.objectConfirm = "";
        this.dataToDelete = this.model;
        console.log(this.dataToDelete);
        this.modalService.open(title, modalSmall);
    }
    public deleteDepartments(model: any) {
        this.departmentService.deleteDepartment(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {
                // this.DeleteDepartmentEventData.emit();
                this.closeDepartmentCreateView();
            });
    }
    public closeDepartmentCreateView() {
        this.departmentListView.emit();
        this.activeModal.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/departments/departments-edit.component.ts